<template>
  <naj-modal
    ref="pdfModalRef"
    :width="1500"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    @onClose="onModalClose"
  >
    <div
      v-if="loading"
      class="loader-holder"
    >
      <naj-loader></naj-loader>
    </div>
    <v-row
      v-else
      class="attachment-row"
    >
      <div class="pdf-container">
        <div class="pdf-wrapper">
          <div class="pdf-holder">
            <embed
              class="pdf-viewer"
              :src="fileUrl"
            >
          </div>
        </div>
      </div>
    </v-row>
  </naj-modal>
</template>

<script>
import { getBlobUrl } from '@/modules/lawsuit/helpers/utils';

import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'PdfModal',
  components: {},
  props: {
    fileName: {
      type: String,
      required: false,
      default: null,
    },
    sharePointId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      document: null,
    };
  },
  computed: {
    fileUrl() {
      return getBlobUrl(this.document, this.isImage);
    },
  },
  mounted() { },
  methods: {
    ...mapActions(['getTrustedSourceAttachment']),
    getJudgementDocument() {
      this.loading = true;
      this.getTrustedSourceAttachment(this.sharePointId)
        .then((attachment) => {
          const contentType = this.isImage ? 'image/png' : 'application/pdf';
          this.document = `data:${contentType};base64,${attachment}`;
        })
        .finally(
          () => (this.loading = false)
        );
    },
    showModal() {
      this.$refs.pdfModalRef.show();
      this.getJudgementDocument();
    },
    closeModal() {
      this.$refs.pdfModalRef.close();
    },
    onModalClose() {
      this.$emit('modalClose');
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-row {
  justify-content: center;
}

.pdf-container {
  height: 100%;
  .pdf-wrapper {
    height: 100%;
    position: relative;
    min-height: 150px;
    .pdf-holder {
      height: inherit;
      text-align: center;
      line-height: 1;
      .pdf-viewer {
        max-height: 100%;
        display: inline-block;
      }
    }
  }
}

embed {
  width: 100%;
  height: 100%;
  min-height: 500px !important;
}
</style>